import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogRef } from '../dialog/dialog-ref';
@Component({
    selector: 'app-approve-request',
    templateUrl: './approve-request.component.html',
    styleUrls: ['./approve-request.component.scss'],
    standalone: false
})
export class ApproveRequestComponent implements OnInit {
  reason: string;
  @Input() data: any;
  isOTPVerified: boolean = false;
  otp: string;
  timer: number;

  constructor(
    private loader: LoaderService,
    private baseService: BaseService,
    private alertService: AlertsService,
    private dialogRef: DialogRef,
    private route: Router,
  ) { }

  ngOnInit(): void {
    this.timer = 0;
    this.reason = "";
    this.otp = "";
    console.log(this.data);
  }

  // checkOTP(event){
  //   if(event.target.value){

  //   }
  // }

  authorizationAction() {
    this.loader.showSpinner();
    let args = "mapped_id:" + this.data.mapped_id + ",user_id:" + this.data.user_id;
    this.baseService.get('RESEND_OTP', args, 'user_relationship_mapping', 'account-management').subscribe(
      (res) => {
        if (res.errCode == 0) {
          this.timer = 30;
          this.countdown(this.timer);
          this.alertService.success(res.message);
          this.loader.hideSpinner();
        } else {
          this.alertService.error(res.message);
          this.loader.hideSpinner();
        }
      });
  }

  countdown(x) {
    if (x === 0) {
      this.timer = x;
      return;
    }
    return setTimeout(() => { this.timer = x; this.countdown(--x); }, 1000)
  }

  approveRequest() {
    if (this.otp != '' && this.otp != undefined) {
      this.loader.showSpinner();
      let data = {
        "login_id": this.data.login_id,
        "extra_data": { "otp_no": this.otp },
        "mapped_id": this.data.mapped_id,
        "user_id": this.data.user_id,
        "remark": this.reason
      }
      this.baseService.add(data, 'user_relationship_mapping', true, 'account-management', 'VERIFY_OTP').subscribe(
        (res) => {
          this.loader.hideSpinner();
          if (res.errCode == 0) {
            this.isOTPVerified = true;
            this.route.navigate(["/search"]).then(() => {
              this.route.navigateByUrl("account-management/user_relationship_format/list");
            });
            this.dialogRef.close();
            this.loader.hideSpinner();
          } else {
            this.alertService.error(res.message);
            this.loader.hideSpinner();
          }
        });
    } else {
      this.loader.hideSpinner();
      this.alertService.error("Fill OTP and proceed");
    }
  }
}
